import { METADATA_TYPE } from './accounts';
import { PARAMETERS } from './global';

export enum ACTIVITY_LOG_TYPE {
  CREATE_AC_BASE_REQUEST = 'create_ac_base_request',
  UPDATE_AC_BASE_REQUEST = 'update_ac_base_request',
  ADD_SITTER_TO_AC_BASE_REQUEST = 'add_sitter_to_ac_base_request',
  ACCEPTED_SITTER_TO_AC_BASE_REQUEST = 'accepted_sitter_to_ac_base_request',
  REJECTED_SITTER_TO_AC_BASE_REQUEST = 'rejected_sitter_to_ac_base_request',
  DELETE_SITTER_FROM_AC_BASE_REQUEST = 'delete_sitter_from_ac_base_request',
  GENERATE_AC_JOBS = 'generate_ac_jobs',
}

export enum ACTIVITY_LOG_ROLE {
  ADMIN = 'admin',
  SITTER = 'sitter',
  PARENT = 'parent',
  SYSTEM = 'system',
}

export enum ACTIVITY_LOG_ACTION {
  CREATE = 'create',
  UPDATE = 'update',
  DELETE = 'delete',
}

export interface ACTIVITY_LOG_ITEM_TYPE {
  id: string;
  number: string;
  created_by: string;
  created_by_role: string;
  action: string;
  type: string;
  description: string;
  metadata: {
    job_id?: string;
    job_ids?: string[];
    parent_id?: string;
  };
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  User: {
    id: string;
    email: string;
    first_name: string;
    last_name: string;
  };
  Admin: {
    id: string;
    email: string;
    full_name: string;
  };
}

export interface AC_ACTIVITY_LOG_LIST_PARAMS extends PARAMETERS {}

export interface ACTIVITY_LOGS_RESULT {
  records: ACTIVITY_LOG_ITEM_TYPE[];
  metadata: METADATA_TYPE;
  params?: AC_ACTIVITY_LOG_LIST_PARAMS;
}
